
import React from 'react';
import { useState, useEffect} from "react";
//import { useState, useEffect, useContext } from "react";
//import { MyContext } from "../../context";


const images = [
	"https://bonafont.com.mx/media/catalog/product/7/5/758104001552_2.jpg?quality=80&bg-color=255,255,255&fit=bounds&height=570&width=570&canvas=570:570&dpr=2 2x",
	"https://bonafont.com.mx/media/catalog/product/7/5/758104001552_2.jpg?quality=80&bg-color=255,255,255&fit=bounds&height=570&width=570&canvas=570:570&dpr=2 2x",
	"https://bonafont.com.mx/media/catalog/product/7/5/758104001552_2.jpg?quality=80&bg-color=255,255,255&fit=bounds&height=570&width=570&canvas=570:570&dpr=2 2x",
	"https://bonafont.com.mx/media/catalog/product/7/5/758104001552_2.jpg?quality=80&bg-color=255,255,255&fit=bounds&height=570&width=570&canvas=570:570&dpr=2 2x",
	"https://bonafont.com.mx/media/catalog/product/7/5/758104001552_2.jpg?quality=80&bg-color=255,255,255&fit=bounds&height=570&width=570&canvas=570:570&dpr=2 2x",
	"https://bonafont.com.mx/media/catalog/product/7/5/758104001552_2.jpg?quality=80&bg-color=255,255,255&fit=bounds&height=570&width=570&canvas=570:570&dpr=2 2x",
	"https://bonafont.com.mx/media/catalog/product/7/5/758104001552_2.jpg?quality=80&bg-color=255,255,255&fit=bounds&height=570&width=570&canvas=570:570&dpr=2 2x",
	"https://bonafont.com.mx/media/catalog/product/7/5/758104001552_2.jpg?quality=80&bg-color=255,255,255&fit=bounds&height=570&width=570&canvas=570:570&dpr=2 2x",
	"https://bonafont.com.mx/media/catalog/product/7/5/758104001552_2.jpg?quality=80&bg-color=255,255,255&fit=bounds&height=570&width=570&canvas=570:570&dpr=2 2x",
	"https://bonafont.com.mx/media/catalog/product/7/5/758104001552_2.jpg?quality=80&bg-color=255,255,255&fit=bounds&height=570&width=570&canvas=570:570&dpr=2 2x"
];


function TicketGallery(){

	const [active, setActive] = useState(0);
	const DELAY = active === 0 || active === images.length - 1 ? 1000 : 500;
	const IS_FIRST = active > 0 ? active - 1 : images.length - 1;
	const IS_LAST = active < images.length - 1 ? active + 1 : 0;


  useEffect(() => {
 
    const IMAGE = document.querySelector(`#img${active}`);
		IMAGE?.scrollIntoView({ behavior: "smooth" });
		const TIMER = setTimeout(() => {
		const DOT = document.querySelector(`#dot${active}`);
			DOT?.scrollIntoView({ behavior: 'smooth' })
		}, DELAY);
		return () => clearTimeout(TIMER);
  
  }, [active, setActive]);


return (
       
    <>
    <div className="card p-3 mb-4">
                <div className="d-flex justify-content-between">
                  {/*   <div className="d-flex flex-row align-items-center">
                        <div className="iconCard"> 
                        <span className="material-symbols-rounded">photo_library</span>
                         </div>
                        <div className="ms-2 c-details">
                            <h6 className="mb-0">Gallery</h6><span>Pending Ticket Approval</span> 
                        </div>
                    </div>*/}
                 {/*  <div className="badge Process"> <span>Site Visit</span> </div> */} 
                </div>
                <div className="mt-3">
                    

               {/*Pictures */}

			   <div>
			<div class="slider-container">
			
				<div class="slider">
					{images.map((image, index) => (
						<img id={`img${index}`} src={image} />
					))}
				</div>
	
			</div>
			<div class="carousel-container">
				<div class="carousel">
					{images.map((image, index) => {
						return (
							<button onClick={() => setActive(index)} style={{ border: active === index ? "1px solid #e0632d" : "" }} className="imageBack">
								<img id={`dot${index}`} src={image} />
							</button>
						);
					})}
				</div>
			</div>
		</div>

			   {/*End Pictures */}


                </div>
            </div>
    </>
)

}

export default TicketGallery;


/*import React from 'react';
import { useState, useEffect} from "react";

const images = [
	"https://bonafont.com.mx/media/catalog/product/7/5/758104001552_2.jpg?quality=80&bg-color=255,255,255&fit=bounds&height=570&width=570&canvas=570:570&dpr=2 2x",
	"https://bonafont.com.mx/media/catalog/product/7/5/758104001552_2.jpg?quality=80&bg-color=255,255,255&fit=bounds&height=570&width=570&canvas=570:570&dpr=2 2x",
	"https://bonafont.com.mx/media/catalog/product/7/5/758104001552_2.jpg?quality=80&bg-color=255,255,255&fit=bounds&height=570&width=570&canvas=570:570&dpr=2 2x",
	"https://bonafont.com.mx/media/catalog/product/7/5/758104001552_2.jpg?quality=80&bg-color=255,255,255&fit=bounds&height=570&width=570&canvas=570:570&dpr=2 2x",
	"https://bonafont.com.mx/media/catalog/product/7/5/758104001552_2.jpg?quality=80&bg-color=255,255,255&fit=bounds&height=570&width=570&canvas=570:570&dpr=2 2x",
	"https://bonafont.com.mx/media/catalog/product/7/5/758104001552_2.jpg?quality=80&bg-color=255,255,255&fit=bounds&height=570&width=570&canvas=570:570&dpr=2 2x",
	"https://bonafont.com.mx/media/catalog/product/7/5/758104001552_2.jpg?quality=80&bg-color=255,255,255&fit=bounds&height=570&width=570&canvas=570:570&dpr=2 2x",
	"https://bonafont.com.mx/media/catalog/product/7/5/758104001552_2.jpg?quality=80&bg-color=255,255,255&fit=bounds&height=570&width=570&canvas=570:570&dpr=2 2x",
	"https://bonafont.com.mx/media/catalog/product/7/5/758104001552_2.jpg?quality=80&bg-color=255,255,255&fit=bounds&height=570&width=570&canvas=570:570&dpr=2 2x",
	"https://bonafont.com.mx/media/catalog/product/7/5/758104001552_2.jpg?quality=80&bg-color=255,255,255&fit=bounds&height=570&width=570&canvas=570:570&dpr=2 2x"
];



function TicketGallery(){

  const [active, setActive] = useState(0);
	const DELAY = active === 0 || active === images.length - 1 ? 1000 : 500;
	const IS_FIRST = active > 0 ? active - 1 : images.length - 1;
	const IS_LAST = active < images.length - 1 ? active + 1 : 0;


  useEffect(() => {
 
    const IMAGE = document.querySelector(`#img${active}`);
		IMAGE?.scrollIntoView({ behavior: "smooth" });
		const TIMER = setTimeout(() => {
		const DOT = document.querySelector(`#dot${active}`);
			DOT?.scrollIntoView({ behavior: 'smooth' })
		}, DELAY);
		return () => clearTimeout(TIMER);
  
  }, [active, setActive]);


    return (
       
        <>
  	<div>
			<div class="slider-container">
			
				<div class="slider">
					{images.map((image, index) => (
						<img id={`img${index}`} src={image} />
					))}
				</div>
	
			</div>
			<div class="carousel-container">
				<div class="carousel">
					{images.map((image, index) => {
						return (
							<button onClick={() => setActive(index)} style={{ border: active === index ? "1px solid #e0632d" : "" }} className="imageBack">
								<img id={`dot${index}`} src={image} />
							</button>
						);
					})}
				</div>
			</div>
		</div>
        </>
    )
}

export default TicketGallery;*/